module.exports = __webpack_public_path__ + "static/logo-dpc-cap-rischio-ad532b61dbbc74ae34d2e698818a6eac.png";